import React from "react";
import { Table, ConfigProvider } from "antd";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";


const PayrollList = () => {
  const { payrollStore } = useStore();
  const {
    payrollDataList,
    loading,
    fetchEmployeeIdPayroll,
    setIsModalVisible,
    setIsEmployeePayrollModal,
    setEmployeePayrollBreakdown
  } = payrollStore;

  // const handleSaveAdjustments = (adjustments) => {
  //   if (currentEmployee) {
  //     updateEmployeePayrollAdjustments(
  //       currentEmployee.employeeId,
  //       currentEmployee.id, // employeePayrollId
  //       adjustments.map(adj => ({
  //         ...adj,
  //         employeeId: currentEmployee.employeeId,
  //         employeePayrollId: currentEmployee.id,
  //       }))
  //     );
  //   }
  //   setAdjustmentModalVisible(false);
  // };

  const handleEmployeeClick = async (record) => {
    await fetchEmployeeIdPayroll(record.employeeId);
    setEmployeePayrollBreakdown(record);
    setIsEmployeePayrollModal(true);
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      align: "center",
      key: "employeeName",
      render: (_, record) => (
        <h4
          style={{ cursor: "pointer" }}
          onClick={() => handleEmployeeClick(record)}
        >
          {record.employeeName}
        </h4>
      ),
    },
    {
      title: "Account No.",
      dataIndex: "accountNo",
      align: "center",
      key: "accountNo",
      render: (_, record) => record.employeeNumber,
    },
    {
      title: "Basic",
      dataIndex: "basicSalary",
      align: "center",
      key: "basicSalary",
      render: (_, record) => record.basicPay,
    },
    {
      title: "Adjustment",
      dataIndex: "adjustment",
      align: "center",
      key: "adjustment",
      render: (_, record) => record.salaryAdjustment,
    },
    {
      title: "Net Pay",
      dataIndex: "netPay",
      align: "center",
      key: "netPay",
      render: (_, record) => record.netPay?.toFixed(0),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <ConfigProvider
        theme={{
          token: {
            boxShadowSecondary:
              "0 4px 8px 0 rgba(0, 0, 0.5, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadiusLG: 8,
          },
          components: {
            Table: {
              headerBg: "#6D6D6D",
              headerColor: "white",
              headerSplitColor: "#6D6D6D",
            },
          },
        }}
      >
        <Table
          rowKey="id"
          columns={columns}
          dataSource={payrollDataList}
          loading={loading}
          rowClassName={() => "custom-dark-row"}
        />

        {/* {currentEmployee && (
          <PayrollAdjustmentModal
            key={currentEmployee.id} // This forces a fresh instance when employee changes
            visible={adjustmentModalVisible}
            onCancel={() => setAdjustmentModalVisible(false)}
            adjustments={currentEmployee.employeePayrollAdjustments || []}
            onSave={handleSaveAdjustments}
            employeeName={currentEmployee.employeeName}
            employeeId={currentEmployee.employeeId}
          />
        )} */}
      </ConfigProvider>
    </div>
  );
};

export default observer(PayrollList);
